import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IOpsRequest, IOpsRequestsSlice } from 'types/opsRequests.interface'
import { OPS_NOW, seedOpsRequests } from 'pages/Operations/Shared/opsRequestsData'

const initialState: IOpsRequestsSlice = {
  requests: seedOpsRequests(),
}

const opsRequestsSlice = createSlice({
  name: 'opsRequests',
  initialState,
  reducers: {
    raiseRequest: (
      state,
      action: PayloadAction<Omit<IOpsRequest, 'id' | 'code' | 'status' | 'declineReason' | 'acknowledgedAt' | 'escalationLevel' | 'createdAt'>>,
    ) => {
      const nextId = state.requests.reduce((m, r) => Math.max(m, r.id), 0) + 1
      state.requests = [
        {
          ...action.payload,
          id: nextId,
          code: `REQ-${String(nextId).padStart(3, '0')}`,
          status: 'open',
          declineReason: null,
          acknowledgedAt: null,
          escalationLevel: 0,
          createdAt: OPS_NOW,
        },
        ...state.requests,
      ]
    },
    acknowledgeRequest: (state, action: PayloadAction<number>) => {
      state.requests = state.requests.map((r) =>
        r.id === action.payload ? { ...r, status: 'acknowledged', acknowledgedAt: OPS_NOW } : r,
      )
    },
    startRequest: (state, action: PayloadAction<number>) => {
      state.requests = state.requests.map((r) => (r.id === action.payload ? { ...r, status: 'in_progress' } : r))
    },
    completeRequest: (state, action: PayloadAction<number>) => {
      state.requests = state.requests.map((r) => (r.id === action.payload ? { ...r, status: 'done' } : r))
    },
    declineRequest: (state, action: PayloadAction<{ id: number; reason: string }>) => {
      state.requests = state.requests.map((r) =>
        r.id === action.payload.id ? { ...r, status: 'declined', declineReason: action.payload.reason } : r,
      )
    },
  },
})

export const { raiseRequest, acknowledgeRequest, startRequest, completeRequest, declineRequest } =
  opsRequestsSlice.actions
export default opsRequestsSlice.reducer
